import './banner.scss';
import 'slick-carousel';
import 'magnific-popup';
// Import * as basicLightbox from 'basiclightbox';

export default () => {
	// Slick slider
	$( '.js-banner-for' ).slick( {
		slidesToShow: 1,
		slidesToScroll: 1,
		swipe: true,
		arrows: true,
		dots: true,
		fade: true,
		rows: 0,
		asNavFor: '.js-banner-nav',
		appendArrows: '.banner__slider-navs',
		appendDots: '.banner__slider-navs',
		nextArrow:
      '<button class=\'slick-next\'><i class=\'icon-arrow-next\'></i></button>',
		prevArrow:
      '<button class=\'slick-prev\'><i class=\'icon-arrow-prev\'></i></button>',
	} );
	$( '.js-banner-nav' ).slick( {
		slidesToShow: 3,
		slidesToScroll: 1,
		asNavFor: '.js-banner-for',
		dots: false,
		arrows: false,
		rows: 0,
		centerMode: true,
		focusOnSelect: true,
		responsive: [ {
			breakpoint: 640,
			settings: {
				slidesToShow: 2,
			},
		} ],
	} );

	let items = [];

	$( '.js-banner-for .banner__item' ).each( function () {
		let $this = $( this );
		let $link = $this.find( 'a' );
		let $img = $this.find( 'img' );

		if ( $link.length > 0 && $link.hasClass( 'js-youtube-video' ) ) {
			// It's a video
			items.push( {
				src: $link.attr( 'href' ),
				type: 'iframe',
			} );
		} else if ( $img.length > 0 ) {
			// It's an image
			items.push( {
				src: $img.attr( 'src' ),
				title: $img.attr( 'alt' ),
			} );
		}
	} );

	$( '.js-banner-for .banner__item' ).on( 'click', function ( event ) {
		event.preventDefault();
		let index = $( this ).data( 'slick-index' );

		$.magnificPopup.open( {
			items: items,
			gallery: {
				enabled: true,
			},
			type: 'image', // This is a default type
			image: {
				markup: '<div class="mfp-figure">' +
					'<div class="mfp-close"></div>' +
					'<div class="mfp-img"></div>' +
					'<div class="mfp-bottom-bar">' +
					'<div class="mfp-title"></div>' +
					'<div class="mfp-counter"></div>' +
					'</div>' +
					'</div>', // Popup HTML markup. `.mfp-img` div will be replaced with img tag, `.mfp-close` by close button

				cursor: 'mfp-zoom-out-cur', // Class that adds zoom cursor, will be added to body. Set to null to disable zoom out cursor.

				titleSrc: 'title', // Attribute of the target element that contains caption for the slide.
				// Or the function that should return the title. For example:
				// TitleSrc: function(item) {
				//   Return item.el.attr('title') + '<small>by Marsel Van Oosten</small>';
				// }

				verticalFit: true, // Fits image in area vertically

				tError: '<a href="%url%">The image</a> could not be loaded.', // Error message
			},
			iframe: {
				markup:
					'<div class="mfp-iframe-scaler">' +
					'<div class="mfp-close"></div>' +
					'<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
					'</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button

				patterns: {
					youtube: {
						index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

						id: 'v=', // String that splits URL in a two parts, second part should be %id%
						// Or null - full URL will be returned
						// Or a function that should return %id%, for example:
						// Id: function(url) { return 'parsed id'; }

						src: '//www.youtube.com/embed/%id%?autoplay=1', // URL that will be set as a source for iframe.
					},
					vimeo: {
						index: 'vimeo.com/',
						id: '/',
						src: '//player.vimeo.com/video/%id%?autoplay=1&muted=1',
					},
					gmaps: {
						index: '//maps.google.',
						src: '%id%&output=embed',
					},

					// You may add here more sources
				},

				srcAction: 'iframe_src',
			},
			callbacks: {
				change: function () {
					// When Magnific Popup changes slide, update slick slider
					let {
						index,
					} = this;

					$( '.js-banner-for' ).slick( 'slickGoTo', index );
				},
			},
		}, index );
	} );


	// Document.querySelectorAll( '.lightbox' ).forEach( ( el ) => {
	// 	El.addEventListener( 'click', () => {
	// 		Let imgSrc = el.src;
	// 		Let imgWidth = el.width;
	// 		Let imgHeight = el.height;

	// 		Console.error( basicLightbox );
	// 		Console.error( `${imgSrc} + ${imgWidth} + ${imgHeight}` );
	// 		BasicLightbox.create( `
	// 		<img width="${imgWidth}" height="${imgHeight}" src="${imgSrc}">
	// 	` ).show( console.error( 'shown' ) );
	// 	} );
	// } );
};
